export class RewriteTableContextResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "rewrite",
            "baseName": "rewrite",
            "type": "TableContextRewrite",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RewriteTableContextResponse.attributeTypeMap;
    }
    constructor() {
    }
}
